"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlackjackScoring = void 0;
const logic_metrics_1 = require("./logic-metrics");
const logic_types_1 = require("./logic-types");
class BlackjackScoring {
    static hasReachedTargetScore(score) {
        const finalScore = score.maxScore <= logic_metrics_1.LogicMetrics.TargetScore
            ? score.maxScore
            : score.minScore;
        return finalScore === logic_metrics_1.LogicMetrics.TargetScore;
    }
    static hasBust(score) {
        return (score.maxScore > logic_metrics_1.LogicMetrics.TargetScore &&
            score.minScore > logic_metrics_1.LogicMetrics.TargetScore);
    }
    static hasPlayerBlackjack(firstCard, secondCard) {
        return ((firstCard.isAce && secondCard.isValuedTen) ||
            (firstCard.isValuedTen && secondCard.isAce));
    }
    static canCroupierDeal(croupierScore) {
        return croupierScore.maxScore < logic_metrics_1.LogicMetrics.SoftLimit;
    }
    static canSplitPlayerCards(playerId, firstCard, secondCard) {
        if (playerId !== logic_types_1.PileId.Player1 && firstCard.cardType === logic_types_1.CardType.Ace) {
            return false;
        }
        return firstCard.cardType === secondCard.cardType;
    }
    static calculateScore(cards, logicVersion) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        let minScore = 0;
        let maxScore = 0;
        const faceUpCards = cards
            .filter((card) => card.isFaceUp)
            .sort((a, b) => { var _a, _b, _c, _d; return ((_b = (_a = b.cardId) === null || _a === void 0 ? void 0 : _a.cardType) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = a.cardId) === null || _c === void 0 ? void 0 : _c.cardType) !== null && _d !== void 0 ? _d : 0); });
        if (logicVersion <= 1) {
            for (const card of faceUpCards) {
                if (((_a = card.cardId) === null || _a === void 0 ? void 0 : _a.cardType) === logic_types_1.CardType.Ace) {
                    const minValue = (_c = (_b = card.cardId) === null || _b === void 0 ? void 0 : _b.blackjackValue.minValue) !== null && _c !== void 0 ? _c : 0;
                    const maxValue = (_e = (_d = card.cardId) === null || _d === void 0 ? void 0 : _d.blackjackValue.maxValue) !== null && _e !== void 0 ? _e : 0;
                    minScore += minValue;
                    maxScore +=
                        maxScore + maxValue > logic_metrics_1.LogicMetrics.TargetScore
                            ? minValue
                            : maxValue;
                }
                else {
                    minScore += (_g = (_f = card.cardId) === null || _f === void 0 ? void 0 : _f.blackjackValue.minValue) !== null && _g !== void 0 ? _g : 0;
                    maxScore += (_j = (_h = card.cardId) === null || _h === void 0 ? void 0 : _h.blackjackValue.maxValue) !== null && _j !== void 0 ? _j : 0;
                }
            }
        }
        else {
            for (const card of faceUpCards) {
                minScore += (_l = (_k = card.cardId) === null || _k === void 0 ? void 0 : _k.blackjackValue.minValue) !== null && _l !== void 0 ? _l : 0;
                maxScore += (_o = (_m = card.cardId) === null || _m === void 0 ? void 0 : _m.blackjackValue.maxValue) !== null && _o !== void 0 ? _o : 0;
            }
            for (const card of faceUpCards) {
                if (((_p = card.cardId) === null || _p === void 0 ? void 0 : _p.cardType) === logic_types_1.CardType.Ace &&
                    maxScore > logic_metrics_1.LogicMetrics.TargetScore) {
                    const value = card.cardId.blackjackValue;
                    maxScore -= value.maxValue;
                    maxScore += value.minValue;
                }
            }
        }
        return { minScore, maxScore };
    }
    static calculateRoundResult(playerScore, croupierScore) {
        const finalPlayerScore = playerScore.maxScore <= logic_metrics_1.LogicMetrics.TargetScore
            ? playerScore.maxScore
            : playerScore.minScore;
        if (croupierScore.maxScore > logic_metrics_1.LogicMetrics.TargetScore) {
            return logic_types_1.RoundResult.PlayerWin;
        }
        if (finalPlayerScore === croupierScore.maxScore) {
            return logic_types_1.RoundResult.Push;
        }
        return finalPlayerScore > croupierScore.maxScore
            ? logic_types_1.RoundResult.PlayerWin
            : logic_types_1.RoundResult.CroupierWin;
    }
    static playerDisplayScore(score, isHandComplete) {
        if (isHandComplete) {
            const finalPlayerScore = score.maxScore <= logic_metrics_1.LogicMetrics.TargetScore
                ? score.maxScore
                : score.minScore;
            return `${finalPlayerScore}`;
        }
        if (score.maxScore > logic_metrics_1.LogicMetrics.TargetScore) {
            return `${score.minScore}`;
        }
        return score.minScore === score.maxScore ||
            score.maxScore === logic_metrics_1.LogicMetrics.TargetScore
            ? `${score.maxScore}`
            : `${score.minScore} / ${score.maxScore}`;
    }
    static croupierDisplayScore(score) {
        // TODO: This goes wrong with A, A, 10
        // if (score.maxScore > LogicMetrics.TargetScore) {
        //   return `${score.minScore}`;
        // }
        return score.minScore === score.maxScore ||
            score.maxScore >= logic_metrics_1.LogicMetrics.SoftLimit
            ? `${score.maxScore}`
            : `${score.minScore} / ${score.maxScore}`;
    }
}
exports.BlackjackScoring = BlackjackScoring;
